<template>
  <van-notice-bar
    v-if="unreadCount > 0"
    class="forum_unread_reply_notice"
    left-icon="volume-o"
    mode="link"
    :scrollable="false"
    :text="noticeText"
    @click="openMessages"
  />
</template>

<script>
import { NoticeBar } from 'vant';
import { getCommunityUnreadReplySummary } from '@/api/forum';

const FETCH_INTERVAL = 500;

export default {
  name: 'ForumUnreadReplyNotice',
  components: { [NoticeBar.name]: NoticeBar },
  data() {
    return {
      type: null,
      unreadCount: 0,
      hasFetched: false,
      lastFetchAt: 0,
    };
  },
  computed: {
    noticeText() {
      if (Number(this.type) === 1) return `您的帖子有${this.unreadCount}条新评论啦，点我去看`;
      if (Number(this.type) === 2) return `您的评论有${this.unreadCount}条新评论啦，点我去看`;
      return '';
    },
  },
  activated() {
    if (this.hasFetched) this.fetchSummary();
  },
  created() {
    this.fetchSummary();
  },
  methods: {
    async fetchSummary() {
      const now = Date.now();
      if (now - this.lastFetchAt < FETCH_INTERVAL) return;
      this.lastFetchAt = now;
      try {
        const res = await getCommunityUnreadReplySummary();
        const data = (res && res.data) || {};
        this.type = data.type;
        this.unreadCount = Number(data.unreadCount) || 0;
      } finally {
        this.hasFetched = true;
      }
    },
    openMessages() {
      this.$router.push({ name: 'forum-messages' });
    },
  },
};
</script>

<style scoped>
.forum_unread_reply_notice {
  position: sticky;
  top: 0;
  z-index: 30;
  min-height: 40px;
  padding: 0 16px;
  color: #8a572a;
  background: #fff4df;
  font-size: 13px;
}
</style>
